import _ from 'lodash';
import { getChartColor } from '../../../../utilities/ColorUtilities';
import { getChartDateTimeLabelFormats } from '../../../../utilities/FormattingUtilities';

const baseDefaultYAxis = {
    visible: false,
    title: {
        text: null,
    },
    type: 'linear',

    // despite being a linear axis, we will still auto-format large values with K,M,G, etc in a way consistent with
    // our tooltips
    labels: {
        valueFormatter: {
            formatter: 'log',
            // Disable less-than formatting, since we don't want that for our axis labels.
            ltValue: -1,
            decimals: 'auto',
        },
    },

    maxPadding: 0,
    min: 0,
    minTickInterval: 0.01,
    allowDecimals: true,
    tickLength: 0,
    lineWidth: 1,
    gridLineWidth: 1,
};

export function getDefaultYAxis(mode) {
    return {
        ...baseDefaultYAxis,
        gridLineColor: getChartColor('gridLines', mode),
        lineColor: getChartColor('gridLines', mode),
        tickColor: getChartColor('yAxisTicks', mode),
    };
}

export function getChart(chartDef, disableYAxis, onChartSelection) {
    if (!chartDef) return undefined;
    const yAxises = chartDef.yAxis;

    return {
        animation: false,
        marginLeft: disableYAxis ? 0 : 85,
        marginRight: yAxises?.length > 1 ? 85 : 0,
        reflow: false,
        spacingBottom: 0,
        spacingLeft: 0,
        spacingRight: 0,
        spacingTop: disableYAxis ? 0 : 10,
        style: {
            fontFamily: 'Roboto, "sans-serif"',
        },
        type: chartDef.chartType,
        zoomType: _.has(chartDef, 'chart.zoomType') ? chartDef.zoomType : 'x',
        snap: true,
        events: {
            selection: onChartSelection,
        },
    };
}

export function getXAxis(disableAxis, plotBands, xAxis, hideLine, themeVariant) {
    return _.merge(
        {
            type: 'datetime',
            plotBands,
            maxPadding: 0,
            minPadding: 0,
            visible: !disableAxis,
            lineColor: getChartColor('gridLines', themeVariant),
            tickColor: getChartColor('xAxisTicks', themeVariant),
            gridLineWidth: 0,
            crosshair: hideLine
                ? undefined
                : {
                      color: getChartColor('crosshair', themeVariant),
                      width: 1,
                      snap: true,
                  },
            minTickInterval: 60_000,
            dateTimeLabelFormats: getChartDateTimeLabelFormats(),
        },
        xAxis || {}
    );
}

export function singleYAxis(def, index, visible, max, themeVariant) {
    return _.merge(
        _.cloneDeep(getDefaultYAxis(themeVariant)),
        {
            visible,
            index,
            max,
        },
        def || {}
    );
}

export function getYAxis(disableYAxis, yAxis, yAxisTop, themeVariant) {
    if (!yAxis) return singleYAxis(undefined, undefined, !disableYAxis, yAxisTop, themeVariant);
    return yAxis.map((def, index) => singleYAxis(def, index, !disableYAxis, yAxisTop, themeVariant));
}
